import Select from 'react-select';

export const CustomSelect = ({
  value,
  options,
  className,
  handleChange,
  isMulti = false,
  placeholder = '',
  customStyle = {},
  isDisabled = false,
  isClearable = false,
  isSearchable = false,
  ...rest
}) => {
  return (
    <Select
      {...rest}
      theme={(theme) => ({
        ...theme,
        borderRadius: 0,
        backgroundColor: '#fafaf9',
        colors: {
          ...theme.colors,
          primary25: '#fafaf9',
          primary50: '#fafaf9',
          primary: 'black',
        },
      })}
      styles={customStyle}
      value={value}
      isMulti={isMulti}
      options={options}
      className={className}
      onChange={handleChange}
      isDisabled={isDisabled}
      placeholder={placeholder}
      isClearable={isClearable}
      isSearchable={isSearchable}
    />
  );
};
